export enum DocumentTypes {
  Other = -1,
  Statement = 0,
  Tax = 2,
}
